/**
 * @description 對應險種類別英文名稱用
 */
export enum InsTypeNameEN {
  All='all',
  Travel= 'travel',
  Car='auto',
  Moto='moto',
  Fire='fire',
  MobileDevice = 'mobiledevice',
  Pet='pet',
  Ecar='ecar',
  Emoto='emoto',
}
